angular.module('swapick')
.controller('WorldCtrl', WorldCtrl);


function WorldCtrl($scope, DataService, $ionicLoading, 
  ionPullUpFooterState, $timeout, $stateParams, 
  Filters, Categories, initialLoaderManager, $q, $state, $ionicHistory) {

  this.worldId = $stateParams.worldId;
  
  this.loader = initialLoaderManager.makeLoader(() => {
    return Categories.getCategories()
    .then(categories => {
      this.categoriesData = Categories.data;
      this.mondo = this.categoriesData.mondiById[this.worldId][0];
      console.log(this.categoriesData)
      return this.categoriesData;
    })


  }, false);

  $scope.$on('$ionicView.afterEnter', () => {
      if(!this.categoriesData){
        this.loader.load();
      }
  });


  this.toHome = (idCat, idWorld) => {
    $ionicHistory.nextViewOptions({
      disableBack: true,
      historyRoot : true,
    });
    
    Filters.setFilter('home.mondo', idWorld);
    Filters.setFilter('home.categoria', idCat);
    $state.go("app.logged.home", { cat:idCat, world:idWorld})  
    
  }

  
}




// WEBPACK FOOTER //
// ./src/controllers/world-controller.js